import { Container, Typography, Card, CardContent, Box } from "@mui/material";
import Footer from "../components/Footer";

const TermsAndConditions = () => {
  const WEBSITE = "Phoenix Play Zone";

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#1f2937",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#1f2937",
          py: 4,
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Container maxWidth="md" sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "white" }}
          >
            Terms and Conditions
          </Typography>
          <Typography variant="subtitle1" color="white">
            Explore our premium courts for futsal, badminton, and more.
          </Typography>
        </Container>
      </Box>
      <Box sx={{ flexGrow: 1, backgroundColor: "#1f2937" }}>
        <div className="max-w-4xl mx-auto px-5">
          <Card className="shadow-lg rounded-2xl" sx={{ backgroundColor: "#1f2937", color: 'white' }}>
            <CardContent>
              <Typography variant="body1" className="mb-4">
                Welcome to {WEBSITE}. These Terms and Conditions
                govern your use of our platform. By using our website, you agree
                to comply with these terms.
              </Typography>
              <br/>
              <Typography variant="h6" className="font-semibold mt-4" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Use of the Website
              </Typography>
              <ul className="list-disc ml-6 mb-4">
                <li>You must be at least 18 years old to use our website.</li>
                <li>Ensure your account credentials remain confidential.</li>
                <li>
                  Provide accurate and current details during registration and
                  checkout.
                </li>
                <li>Do not use our website for illegal activities.</li>
              </ul>
              <br/>
              <Typography variant="h6" className="font-semibold mt-4" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Orders and Payments
              </Typography>
              <ul className="list-disc ml-6 mb-4">
                <li>
                  All bookings are final, no refunds will be issued after
                  confirmation.
                </li>
                <li>Ensure valid payment information is provided.</li>
                <li>We use secure third-party payment processors.</li>
              </ul>
              <br/>
              <Typography variant="h6" className="font-semibold mt-4" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Intellectual Property
              </Typography>
              <Typography variant="body1" className="mb-4">
                All content on our website, including text, images, and logos,
                belongs to {WEBSITE}. You may not reproduce or
                modify any material without permission.
              </Typography>
              <br/>
              <Typography variant="h6" className="font-semibold mt-4" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Limitation of Liability
              </Typography>
              <Typography variant="body1" className="mb-4">
                We are not liable for any damages arising from your use of our
                website or services.
              </Typography>
              <br/>
              <Typography variant="h6" className="font-semibold mt-4" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Amendments
              </Typography>
              <Typography variant="body1">
                We reserve the right to update these Terms at any time.
                Continued use of the website indicates acceptance of the revised
                terms.
              </Typography>
            </CardContent>
          </Card>
        </div>
      </Box>
      <Footer />
    </Box>
  );
};

export default TermsAndConditions;
